export function initialize(store, router) {
  router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const token = store.getters.token;
    if(requiresAuth && !token) {
      next('/login');
    } else if(to.path == '/login' && token) {
      next('/');
    } else {
      next();
    }
  });

  if (store.getters.token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${store.getters.token}`;
  }

  axios.interceptors.response.use(null, (err) => {
    if (err.response) {
      if (err.response.status === 401 && err.response.data.message && !Swal.isVisible()) {
        Swal.fire('Упс!', err.response.data.message, 'error')
          .then((ok) => {
            if (router.currentRoute.name !== 'login') {
              store.commit('LOGOUT');
              router.push('/login');
            }
          });
      }
      if (err.response.status === 500) {
        if (!Swal.isVisible()) {
          Swal.fire('Похоже, что-то пошло не так.', 'К сожалению, у нас возникли проблемы с заполнением вашего запроса прямо сейчас. Пожалуйста, попробуйте еще раз в ближайшее время.', 'error')
            .then((ok) => {
                if (ok) {
                  router.go(-1);
                }
            });
        }

      }
      if (err.response.status === 403) {
        if (!Swal.isVisible()) {
          Swal.fire('Отказано в доступе', 'У вас нет разрешения на доступ', 'error')
            .then((ok) => {
              if (ok) {
                router.go(-1);
              }
            });
        }
      }
      if (err.response.status === 404) {
        if (!Swal.isVisible()) {
          Swal.fire('Ошибка', 'Ошибка на стороне клиента', 'error')
            .then((ok) => {
              if (ok) {
                router.go(-1);
              }
            });
        }
      }
    }
    return Promise.reject(err);
  });
}
